module.exports = __webpack_public_path__ + "static/media/cz.49044310.svg";